<template>
  <div v-if="Object.keys(recrutest).length <= 0">
    <div class="hidden w-full md:flex flex-row nxp-re-container">
      <img src="@/assets/images/re_vagas.png" alt="">
      <div class="nxp-re-container-text">
        <h3>
          Aumente suas chances de emprego!
        </h3>
        <p>
          Faça <b>Recrutest DISC</b> para descobrir seu perfil comportamental e
          aumentar suas chances de ser selecionado
        </p>
      </div>
      <button class="nxp-re-button" :style="{ backgroundColor: color }" @click="onRecrutestClick()">
        Faça o Recrutest
      </button>
    </div>

    <div class="flex w-full md:hidden flex-col nxp-re-container-mobile">
      <div class="nxp-re-mobile-wrapper">
        <img src="@/assets/images/re_vagas.png" alt="">
        <div class="w-full flex flex-row items-center">
          <div class="nxp-re-container-text">
            <h3>
              Aumente suas chances de emprego!
            </h3>
            <p>
              Faça <b>Recrutest DISC</b> para descobrir seu perfil comportamental e
              aumentar suas chances de ser selecionado
            </p>
          </div>
        </div>
      </div>
      <button class="nxp-re-button w-full" :style="{ backgroundColor: color }" @click="onRecrutestClick()">
        Faça o Recrutest
      </button>
    </div>
  </div>
  <div v-else-if="showResult"
    class="result-container w-full flex flex-col md:flex-row items-center gap-4 p-6 md:pl-0 md:py-0"
  >
    <div class="icon-column hidden md:flex">
      <img :src="recrutest.icon" alt="recrutest icone" width="180" height="180"/>
    </div>
    <div class="text-column">
      <p class="section-title">Seu perfil comportamental</p>
      <h2>
        Perfil: {{ recrutest.title }}
      </h2>
      <p>{{ descriptions.find(profile => profile.title === recrutest.title).description }}</p>
    </div>
    <div class="buttons-column">
      <vs-button
        :color="color"
        type="border"
        @click="onRecrutestClick(recrutest['profile-link'])"
      >
        Ver resultado completo
      </vs-button>
      <vs-button
        color="primary"
        type="flat"
        @click="redoRecrutest()"
      >
        Refazer o Recrutest
      </vs-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'RecrutestBanner',
  data() {
    return {
      recrutest: {},
      descriptions: [
        {
          title: 'Realizador',
          description: 'O Realizador demonstra grande interesse em seu trabalho, busca contínua por realização pessoal e possui forte senso de responsabilidade, alinhando metas pessoais e empresariais.'
        },
        {
          title: 'Diplomático',
          description: 'O Diplomático equilibra relações humanas e tarefas, é empático, promove harmonia e trabalho em equipe, fazendo com que as pessoas ao seu redor se sintam necessárias e valorizadas.'
        },
        {
          title: 'Observador',
          description: 'O Observador transforma ideias em resultados práticos, é competitivo, persuasivo e auxilia no planejamento, extraindo a cooperação de todos ao explicar os benefícios do cumprimento das metas.'
        },
        {
          title: 'Conselheiro',
          description: 'O Conselheiro é empático, otimista e paciente, foca em relações duradouras, oferece sugestões de forma gentil e evita impor suas ideias aos outros.'
        },
        {
          title: 'Criativo',
          description: 'O Criativo busca perfeição e resultados, é visionário, analítico e independente, apresentando boa capacidade de planejamento e desejando trazer mudanças com os resultados que atinge.'
        },
        {
          title: 'Projetista',
          description: 'O Projetista é individualista, inovador e persistente, busca constantemente novos horizontes, é auto-suficiente e gosta de pensar de forma independente, criando soluções inovadoras.'
        },
        {
          title: 'Inspirador',
          description: 'O Inspirador influencia e persuade, adapta seu discurso para conquistar aliados, tem clareza em seus objetivos e é sedutor em sua forma de agir, sendo bem visto no ambiente de trabalho.'
        },
        {
          title: 'Investigador',
          description: 'O Investigador é analítico, determinado e busca metas claras, agindo com lógica e preferindo trabalhar de forma independente, respondendo às situações de forma mais lógica do que emocional.'
        },
        {
          title: 'Objetivo',
          description: 'O Objetivo é crítico, meticuloso e focado em eficiência, dá ênfase nos fatos ao tirar conclusões e sempre planeja suas ações visando a eficiência e a exatidão.'
        },
        {
          title: 'Perfeccionista',
          description: 'O Perfeccionista é meticuloso, sistemático e focado em procedimentos, busca estabilidade e possui um pensamento ordenado, sendo extremamente diligente em tarefas que exigem atenção aos detalhes.'
        },
        {
          title: 'Influenciador',
          description: 'O Influenciador é sociável, carismático e trabalha bem em grupo, impressiona e atrai pessoas com suas ideias, criando e mantendo amizades ou clientes com facilidade.'
        },
        {
          title: 'Profissional',
          description: 'O Profissional busca maestria, monitora seu aprendizado, foca na excelência e tem altas expectativas, projetando uma imagem de relaxado e descontraído em interações sociais, mas sendo focado no trabalho.'
        },
        {
          title: 'Incentivador',
          description: 'O Incentivador é sociável, constrói redes de contato, promove ideias e possui o dom da fala, utilizando-o para promover projetos das pessoas com quem tem proximidade.'
        },
        {
          title: 'Orientado a Resultados',
          description: 'O Orientado a Resultados é confiante, competitivo e focado em desafios, está sempre procurando novas oportunidades para testar e desenvolver suas habilidades e capacidade de entrega.'
        },
        {
          title: 'Especialista',
          description: 'O Especialista é modesto, consistente e focado em especialização, é considerado agradável de se conviver, eficiente em áreas que requerem alto grau de especialização e atinge performance consistente.'
        },
      ]
    }
  },
  props: {
    showResult: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('basicInfo', ['basicInfo']),
    ...mapState('address', ['address']),
    ...mapState("company", ["company"]),
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  created() {
    this.doRecrutest();
  },
  methods: {
    doRecrutest() {
      if (!this.basicInfo || !this.basicInfo.email) return;

      axios
        .get(
          `https://recrutest.recrutei.com.br/public/get-profile/1ae32id23if349vmv39f9hewvn8/${this.basicInfo.email}`,
          { headers: { "Access-Control-Allow-Origin": "*" } }
        )
        .then(async ({ data }) => {
          this.recrutest = await Object.assign({}, this.recrutest, { ...data });
        })
        .catch(console.error);
    },
    onRecrutestClick(link) {
      // PostHog: recrutest_clicked
      (async () => {
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("recrutest_clicked", {
            has_link: Boolean(link),
          });
        } catch (_) {}
      })();
      if (link !== undefined) return window.open(link, "_blank");

      const ssn = this.basicInfo.ssn.replace(/\./g, "").replace(/-/g, "");
      const url = `https://recrutest.recrutei.com.br/register/web/new?name=${this.basicInfo.name}&email=${this.basicInfo.email}&ssn=${ssn}&city=${this.address.city}`;
      window.open(url, "_blank");
    },
    redoRecrutest() {
      // Talento já possui Recrutest: manda para o login (não para o cadastro),
      // com o e-mail já preenchido no formulário.
      (async () => {
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("recrutest_clicked", {
            has_link: false,
            redo: true,
          });
        } catch (_) {}
      })();

      const email = encodeURIComponent(this.basicInfo.email || "");
      const url = `https://recrutest.recrutei.com.br/login?email=${email}`;
      window.open(url, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
.nxp-re-container-mobile {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  gap: 16px;
  border-radius: 16px;
  background: #ECEBEB;
}

.nxp-re-mobile-wrapper img {  
  display: none;
}

.nxp-re-mobile-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
}

.nxp-re-mobile-wrapper .nxp-re-container-text {
  max-width: 100%;
  text-align: center;
  align-items: center;
}

.nxp-re-mobile-wrapper .nxp-re-container-text h3 {
  text-align: center;
}

.nxp-re-mobile-wrapper .nxp-re-container-text p {
  text-align: center;
}

.nxp-re-mobile-wrapper button {
  width: 100%;
  position: static;
}

.nxp-re-container {
  height: 130px;
  display: flex;
  padding: 24px 16px 24px 160px;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  background: #ECEBEB;
  position: relative;
}

.nxp-re-container img {
  position: absolute;
  bottom: 0;
  left: 0;
}

.nxp-re-container-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 340px;
}

.nxp-re-container-text h3 {
  color: #333;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.nxp-re-container-text p {
  color: #696969;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-re-container-text p b {
  color: #4F4F4F;
  font-weight: 600;
}

.nxp-re-button {
  display: flex;
  height: 48px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #309E3A;
  color: #FFF;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  cursor: pointer;
  margin-left: auto;
  transition: all ease 0.3s;
}

.nxp-re-button:hover {
  filter: brightness(0.9);
}

.result-container {
  border: 0.5px solid #A8A8A8;
  border-radius: 16px;

  .icon-column {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    img {
      max-width: 100%;
    }
  }

  .text-column {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 1;

    .section-title {
      font-size: 12px;
      font-weight: 400;
      line-height: 14.06px;
      color: #4f4f4f;
    }

    h2 {
      font-size: 20px;
      font-weight: 600;
      line-height: 23.44px;
      color: #333;
      margin: 4px 0 8px 0;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 18.75px;
    }

  }
  
  .buttons-column {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style> 
